export { e as extendConfig, g as generateConfig, p as provideDyteDesignSystem } from './config-bad8bfb3.js';
export { d as defaultConfig } from './default-ui-config-da9eb9e4.js';
export { d as defaultIconPack, a as defaultLanguage } from './default-language-8e524383.js';
export { D as DyteNotificationsAudio } from './notification-8c0067e0.js';
export { g as generateChatGroupKey, a as getChatGroups, c as getParticipantUserId, b as getUnreadChatCounts } from './chat-0611caa4.js';
import './isObjectLike-b5266db7.js';
import './logger-8eaa31ac.js';
import './user-prefs-f52d234f.js';
import './graceful-storage-33bc316d.js';

/**
 * Send notification which will be displayed in the `<dyte-notifications />` component.
 * @param notification Notification object
 * @param playSound Sound type, if sound type is sent plays that sound with the notification.
 * @returns Return value of emitting the event
 */
const sendNotification = (notification, playSound = undefined) => {
  if (typeof document === 'undefined')
    return false;
  const event = new CustomEvent('dyteNotification', {
    detail: Object.assign(Object.assign({}, notification), { playSound }),
    composed: true,
  });
  return document.dispatchEvent(event);
};

export { sendNotification };
